export default async function (context) {
  // console.log('Middleware!')
  await context.store.dispatch('site/updateSiteState', context);
}
